export default __webpack_public_path__ + "static/media/wordIcon.446ca23e.svg";